import { FC, ReactNode } from 'react';

interface ICustomTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: number | string;
    index: number;
  };
  tickFormatter?: (value?: number | string) => ReactNode;
  isXAxis?: boolean;
}

export const CustomAxisTick: FC<ICustomTickProps> = ({
  x,
  y,
  payload,
  tickFormatter,
  isXAxis,
}) => {
  let dy = 16;
  let dx = 0;
  let textAnchor: string | undefined = 'start';

  if (isXAxis) {
    textAnchor = 'end';
    if (payload?.index === 0) {
      textAnchor = undefined;
    }
  } else {
    dy -= 16;
    dx -= 60;
  }

  return (
    <text
      x={x}
      y={y}
      dx={dx}
      dy={dy}
      textAnchor={textAnchor}
      fill="var(--text-secondary)"
      fontSize={14}
    >
      {tickFormatter ? tickFormatter(payload?.value) : payload?.value}
    </text>
  );
};
